'use es6'; // TODO: Use BE Attributes or IndexedDB?

import { userPortal as userPortalLocalStorage, tryConvertLegacyStorage } from 'DesignData/lib/localStorage';
import { CODEMIRROR_SESSION } from 'DesignData/enums/attributes/UserPortal';
const legacyKeySuffix = 'codemirror:session';
/**
 * @param {Number} userId
 * @param {Number} portalId
 * @returns {Promise}
 */

export function fetch(userId, portalId) {
  const storageClient = userPortalLocalStorage(userId, portalId, CODEMIRROR_SESSION);
  return tryConvertLegacyStorage(storageClient, legacyKeySuffix) || storageClient.fetchAsync();
}
/**
 * @param {Number} userId
 * @param {Number} portalId
 * @param {Object} data
 * @returns {Promise}
 */

export function save(userId, portalId, data) {
  const storageClient = userPortalLocalStorage(userId, portalId, CODEMIRROR_SESSION);
  return storageClient.saveAsync(data);
}
/**
 * @param {Number} userId
 * @param {Number} portalId
 * @returns {Promise}
 */

export function del(userId, portalId) {
  const storageClient = userPortalLocalStorage(userId, portalId, CODEMIRROR_SESSION);
  return storageClient.delAsync();
}